import React from 'react';

const AmountFundedToolTip = () => (
    <div>
        Recommended calculation for the Amount Funded:
        <ul>
            <li>
                <strong>PAP:</strong> calculate full cost of drug multiplied by allowed number of fills per year.
            </li>
            <li>
                <strong>Copay Card:</strong> maximum annual amount covered. If N/A, follow calculation for PAP.
            </li>
            <li>
                <strong>Foundation:</strong> total amount awarded/granted.
            </li>
            <li>If funding source will also be used for other drugs, split amount evenly between each of them.</li>
            <li>
                For additional information, see “Calculating Amount funded” resource in the Therigy Knowledge Network.
            </li>
        </ul>
    </div>
);

export default AmountFundedToolTip;
